import { Injectable } from '@angular/core';
import { Station } from './station.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { TimerService } from '../timer/timerService.service';
import { Router } from '@angular/router';
import { StationList } from './stations-list';
import { LeaderBoardService } from '../leader-board/leaderBoardService.service';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { TriviaGameService } from '../trivia-game/triviaGameService.service';
import { AudioServiceService } from '../audio-service.service';

@Injectable({ providedIn: 'root' })
export class MatchGameService {

  stationsList = new StationList().stations;
  randomStations: Station[] = [];
  currentStations = new Subject<Station[]>();
  totalStations = new BehaviorSubject([]);
  stationsArray = [];
  lanes = [];
  didYouKnowCounter = 0;
  didYouKnow = new Subject<boolean>();

  constructor(
    private timerService: TimerService,
    private leaderBoardService: LeaderBoardService,
    private triviaGameService: TriviaGameService,
    private gamePlayService: GamePlayService,
    private router: Router,
    private audioService: AudioServiceService) { }

  startGame() {
    if (this.stationsArray.length == 0) {
      this.timerService.startTimer();
      this.newLevel();
    } else {
      return;
    }
  }

  newLevel() {
    console.log(this.gamePlayService.level.getValue());

    this.lanes = [];
    let center = false;
    const currentLevel = this.gamePlayService.level.getValue();

    switch (currentLevel) {
      case 1:
        center = true;
        this.stationsArray = this.stationsList.filter((station, index) => station.center && index < 5);
        this.lanes.push({
          color: '#ffffff',
          name: 'תחנות מרכזיות'
        });
        break;
      case 2:
        center = true;
        this.stationsArray = this.stationsList.filter((station, index) => station.center && index >= 5);
        this.lanes.push({
          color: '#ffffff',
          name: 'תחנות מרכזיות'
        });
        break;
      case 3:
        this.lanes.push({
          color: '#958b34',
          name: ' ת"א סבידור מרכז - באר-שבע מרכז'
        }, {
          color: '#7030a0',
          name: 'כרמיאל - באר-שבע מרכז'
        }, {
          color: '#006837',
          name: 'כרמיאל - באר-שבע מרכז'
        },
          {
            color: '#ff33cc',
            name: 'ת"א סבידור מרכז - בית שמש'
          });
        break;
      case 4:
        this.lanes.push({
          color: '#948a54',
          name: 'מודיעין מרכז - ירושלים'
        }, {
          color: '#ff99ff',
          name: 'נהריה - ירושלים'
        },
          {
            color: '#ff9900',
            name: 'הרצליה - רחובות'
          });
        break;
      case 5:
        this.lanes.push({
          color: '#a6a6a6',
          name: 'הרצליה - ירושלים'
        }, {
          color: '#0c25ba',
          name: 'הרצליה - באר-שבע מרכז'
        },
          {
            color: '#000000',
            name: 'נתניה - מודיעין מרכז'
          });
        break;
      case 6:
        this.lanes.push({
          color: '#630',
          name: 'נהריה - חיפה חוף הכרמל'
        }, {
          color: '#00cc00',
          name: 'הרצליה - הראשונים'
        }, {
          color: '#ff0000',
          name: 'בנימינה - אשקלון'
        },
          {
            color: '#a21026',
            name: 'בית שאן - עתלית'
          });
        break;
      default:
        break;
    }

    if (!center) {
      this.stationsList.forEach(station => {
        station.color.forEach(stationColor => {
          this.lanes.forEach(lane => {
            if (lane.color == stationColor && !station.center) {
              if (this.stationsArray.indexOf(station) == -1) {
                this.stationsArray.push(station);
              }
            }
          });
        });
      });
    }
    this.currentStations.next(this.stationsArray);
    this.getRandomStation();
  }

  getRandomStation() {
    const currentLevel = this.gamePlayService.level.getValue();
    this.randomStations = [];
    let total: Station[] = [];
    let availableStations = this.stationsList;
    this.stationsArray.forEach(currentStation => {
      availableStations = availableStations.filter(station => station != currentStation);
    });
    let randoms: number[] = [];

    while (randoms.length < (currentLevel < 4 ? 3 : 4)) {
      let random = Math.floor(Math.random() * availableStations.length);
      for (let i = 0; i < randoms.length; i++) {
        if (random == randoms[i]) {
          random = Math.floor(Math.random() * availableStations.length);
          i = -1;
        }
      }
      randoms.push(random);
    }
    randoms.forEach(random => this.randomStations.push(availableStations[random]));
    total = this.stationsArray.concat(this.randomStations);

    /////////// MIX stations ///////////

    let mixNums: number[] = [];
    let mixedStations: Station[] = [];
    mixNums = this.triviaGameService.randomNums(total.length, total.length);
    console.log(mixNums);

    for (let i = 0; i < total.length; i++) {
      mixedStations[i] = total[mixNums[i]];
    }
    this.totalStations.next(mixedStations);
  }

  wrongAnswer() {
    this.gamePlayService.bonus.next(false);
    const newLifes = this.gamePlayService.lifes.getValue() - 1;
    this.gamePlayService.lifes.next(newLifes);
    this.gamePlayService.combo = 0;
    if (newLifes == 0) {
      this.gameOver();
    } else {
      let flash = document.createElement('DIV');
      flash.classList.add('flash');
      document.body.appendChild(flash);
      setTimeout(() => {
        flash.remove();
      }, 200);
    }
  }

  rightAnswer(name: string) {
    // this.gamePlayService.bonus.next(false);
    if (this.didYouKnowCounter >= 3) {
      this.didYouKnow.next(true);
    } else {
      this.didYouKnowCounter++;
    }
    let time = this.timerService.scoreSeconds.getValue();

    if (time >= 100) {
      time = 100;
    } else if (time <= 10) {
      time = 10;
    }

    this.gamePlayService.combo++;
    if (this.gamePlayService.combo == 4 || this.gamePlayService.combo == 8 || this.gamePlayService.combo == 12) {
      this.gamePlayService.bonus.next(true);
    } else {
      this.gamePlayService.bonus.next(false);
    }

    const oldScore = this.gamePlayService.score.getValue();
    const currentScore = Math.round(10000 / time);
    console.log(currentScore, time);

    // console.log('TIME', time);

    if (this.gamePlayService.bonus.getValue()) {
      // console.log("BOOMBOOMBOOMMMMMMMMMMMMMMMMMMM");
      // console.log('currentScore', currentScore);

      this.gamePlayService.score.next(oldScore + (currentScore * this.gamePlayService.combo));
    } else {
      this.gamePlayService.score.next(oldScore + currentScore);
    }
    // console.log(oldScore, currentScore, this.gamePlayService.bonus.getValue());

    if (this.gamePlayService.combo == 12) {
      this.gamePlayService.combo = 0;
    }
    // this.gamePlayService.bonus = false;
    // this.gamePlayService.bonus.next(false);

    this.timerService.restartScoreTimer();

    let total = this.totalStations.getValue().filter(station => station.name != name);
    this.stationsArray = this.stationsArray.filter(station => station.name != name);
    // this.currentStations.next(this.stationsArray);
    // this.totalStations.next(this.stationsArray.concat(this.randomStations));
    this.totalStations.next(total);

    if (this.stationsArray.length == 0) {
      if (this.gamePlayService.level.getValue() < 6) {
        setTimeout(() => {
          this.gamePlayService.level.next(this.gamePlayService.level.getValue() + 1);
          this.newLevel();
        }, 1000);
      } else {
        this.gameOver();
      }
    }
    // if (this.stationsArray.length == 0 && (this.gamePlayService.level.getValue() == 6)) {
    //   this.gameOver();
    // } else {

    // }
  }

  resetMatch() {
    this.stationsList = new StationList().stations;
    this.stationsArray = [];
    this.didYouKnowCounter = 0;
    this.timerService.pauseTimer();
    this.timerService.resetScoreTimer;
  }

  gameOver() {
    this.resetMatch();
    this.checkScore();
  }

  checkScore() {
    const boardIndex = this.leaderBoardService.boardIndex;
    this.gamePlayService.newPlayer.next(true);

    if (this.leaderBoardService.board[boardIndex].topPlayers.length < 5) {
      this.gamePlayService.addLeaderBoard = true;
    } else {
      const scoreList = this.leaderBoardService.board[boardIndex].topPlayers.map((player) => {
        return player.score;
      });
      const minScore = Math.min(...scoreList);
      if (this.gamePlayService.score.getValue() > minScore) {
        this.gamePlayService.addLeaderBoard = true;
        this.audioService.playAudio('winner');
      } else {
        this.gamePlayService.addLeaderBoard = false;
        this.audioService.playAudio('gameOver');
      }
    }

  }
}